import styled from 'styled-components'

const Title = styled.div`
    margin-top: 20px;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
`

const Content = styled.div`
    width: 100%;
    height: 800px;
    max-width: 100%;
    overflow-y: scroll;
    box-shadow: 0px 0px 3px #949494;
    padding: 10px;
    border-radius: 5px;
    text-align: center;
    margin: 0 auto;
    margin-top: 30px;
`

export {
    Title,
    Content
}